window.onscroll = function () {
  myFunction();
};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var onTop = document.getElementById("onTop");
  var height =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("progress").style.width = scrolled + "%";
  if (scrolled > 15) {
    onTop.classList.add("show");
  } else if (scrolled < 15) {
    onTop.classList.remove("show");
  }
}
